module.exports = __webpack_public_path__ + "static/media/mailchimp.9d87fbea.png";